var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BlockContainer',[(!!_vm.terms)?_c('ContentArea',[_c('ContentTitle',[_vm._v(_vm._s(_vm.terms.title))]),_c('ContentParagraph',{staticClass:"whitespace-pre-wrap"},[_vm._v(_vm._s(_vm.terms.terms))])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }